// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__fWDIj","slider__video":"slider_slider__video__JuW5b","slider__photo":"slider_slider__photo__N8zvz"};